import * as buffer from 'buffer';
import process from 'process/browser';

if (typeof window !== 'undefined') {
  window.Buffer = buffer.Buffer;
  window.process = process;
}
